import apiClient from './apiClient';

const roleService = {
  /**
   * Get all roles
   */
  getAll: async (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams({
      page,
      limit,
      ...filters
    });
    const response = await apiClient.get(`/roles?${params}`);
    return response.data;
  },

  /**
   * Create new role
   */
  create: async (roleData) => {
    const response = await apiClient.post('/roles', roleData);
    return response.data;
  },

  /**
   * Get role details
   */
  getById: async (id) => {
    const response = await apiClient.get(`/roles/${id}`);
    return response.data;
  },

  /**
   * Update role
   */
  update: async (id, roleData) => {
    const response = await apiClient.put(`/roles/${id}`, roleData);
    return response.data;
  },

  /**
   * Delete role
   */
  delete: async (id) => {
    const response = await apiClient.delete(`/roles/${id}`);
    return response.data;
  }
};

export default roleService;
